import { ChangeEventHandler, FormEvent, FunctionComponent, useCallback, useState } from 'react';
import { StepContainer } from '../../../StepContainer';
import { useBookingRequestCheckoutContext } from '../../../CheckoutContext/BookingRequestContext';
import { TextArea } from '@cademy-ui/form';

export type MessageStepProps = {};

export const MessageStep: FunctionComponent<MessageStepProps> = () => {
    const { course, educator, checkoutState, submitResponse } = useBookingRequestCheckoutContext();
    const [message, setMessage] = useState<string>(
        checkoutState.stepState.message.state?.message || ''
    );

    const onMessageChange: ChangeEventHandler<HTMLTextAreaElement> = useCallback(
        (event) => {
            setMessage(event.target.value);
        },
        [setMessage]
    );

    const onContinue = useCallback(() => {
        submitResponse({
            actionType: 'message filled',
            payload: {
                message: message,
            },
        });
    }, [message, submitResponse]);

    const onFormSubmit = useCallback((event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
    }, []);

    const onBackClick = useCallback(() => {
        return submitResponse({ actionType: 'go back', payload: {} });
    }, [submitResponse]);

    return (
        <form onSubmit={onFormSubmit}>
            <StepContainer
                course={course}
                optimisticCheckoutState={checkoutState}
                onContinueClick={onContinue}
                onBackClick={onBackClick}
            >
                <h1>Message</h1>
                <TextArea
                    label={`Write a message for ${educator.name}`}
                    name="message"
                    value={message}
                    onChange={onMessageChange}
                    autoFocus={true}
                />
            </StepContainer>
        </form>
    );
};
